// extracted by mini-css-extract-plugin
module.exports = {"nav":"styles_nav__QLm3K","links":"styles_links__5yKdP","link":"styles_link__Xb11a","active":"styles_active__kDSw6"};